import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

// Opens the browser print dialog for a PDF blob via a hidden iframe (not blocked by popup blockers).
export const printPdfBlob = (blob) => {
  const url = URL.createObjectURL(blob);
  const frame = document.createElement("iframe");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  frame.setAttribute("data-testid", "print-frame");
  frame.src = url;
  frame.onload = () => {
    try { frame.contentWindow.focus(); frame.contentWindow.print(); }
    catch { window.open(url, "_blank"); }
    setTimeout(() => { URL.revokeObjectURL(url); frame.remove(); }, 60_000);
  };
  document.body.appendChild(frame);
};

// Generates MICR checks for a run and opens the print dialog. Returns the check range string or null.
export const printRunChecks = async (runId, payslipIds) => {
  try {
    const res = await api.post(`/check-setup/print/${runId}`, { payslip_ids: payslipIds || [], cover: false }, { responseType: "blob" });
    printPdfBlob(res.data);
    return res.headers["x-check-range"] || "";
  } catch (e) {
    let msg = "Could not generate the check";
    try { msg = formatApiErrorDetail(JSON.parse(await e.response?.data?.text())?.detail) || msg; } catch { /* not json */ }
    toast.error(`${msg} — you can print it later from Check Printing`);
    return null;
  }
};
